import React from "react";

import { Stack, SvgIconProps, SxProps } from "@mui/material";

const RollupFilterIcon = ({
  icon: Icon,
  sx,
}: {
  icon: React.FunctionComponent<SvgIconProps>;
  sx?: SxProps;
}) => {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{
        bgcolor: "shades.primary.500",
        borderRadius: "4px",
        p: "2px",
        height: "24px",
        width: "24px",
        mr: "10px",
        ...sx,
      }}
    >
      <Icon sx={{ color: "#FFF", width: "16px" }} />
    </Stack>
  );
};

export default RollupFilterIcon;
